import { useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import './communities.scss';

import CustomPagination from "../../uiKit/CustomTable/pagination";
import CommunityCard from "../../components/CommunityCard/communityCard";
import CommunitiesHeader from "./communitiesHeader";

import { getApprovedCommunities, getCommunities } from "../../redux/state/communitySlice";
import CustomMobilePagination from "../../uiKit/CustomTable/mobilePagination";
import AnimatedLoading from "../../uiKit/Loading/animatedLoading";
import { unwrapResult } from "@reduxjs/toolkit";

const AllCommunities = () => {
    const dispatch = useDispatch();
    const { search, pathname } = useLocation();
    const query = useMemo(() => new URLSearchParams(search), [search]);

    const [pageSize, setPageSize] = useState(8);
    const [isLoading, setIsLoading] = useState(false);

    const communities = useSelector(state => state.community.approvedCommunities, shallowEqual);
    const memberCommunities = useSelector(state => state.community.memberCommunities, shallowEqual);
    const screenWidth = useSelector(state => state.common.screenWidth, shallowEqual);

    useEffect(() => {
        const searchString = query.get('searchString') ?? "";
        const page = parseInt(query.get('page') ?? 1);
        setIsLoading(true)
        const timeout = setTimeout(() => {
            dispatch(getApprovedCommunities({
                page,
                pageSize,
                searchString,
            })).then(unwrapResult).finally(() => setIsLoading(false))
        }, [1000])

        return () => clearTimeout(timeout)
    }, [dispatch, query, pageSize])

    useEffect(() => {
        if (!!memberCommunities) return;
        dispatch(getCommunities())
    }, [
        memberCommunities,
        dispatch,
    ])

    return (
        <>
            <CommunitiesHeader />
            <div className="communityCardsWrapper minHeight350" >
                {
                    !!communities?.items && !!memberCommunities && communities.items.map(x => (
                        <div className="card" >
                            <CommunityCard community={x} key={x.id} isMember={memberCommunities.find(y => y.id === x.id)} />
                        </div>
                    ))
                }
                {
                    screenWidth > 900 ? <CustomPagination
                        data={communities}
                        style={{ width: 'calc(100% - 16px)', borderRadius: '8px' }}
                    /> : <CustomMobilePagination
                        tableUrl={pathname}
                        count={communities.totalNumberOfItems}
                        data={communities}
                        setItems={setPageSize}
                    />
                }
                <AnimatedLoading loading={isLoading} />
            </div>
        </>
    )
}

export default AllCommunities;